import _ from 'lodash';

import { RESET_STATE } from 'store/global/actions';

import { USER_LICENSE_ACTION_TYPE } from '../actions';

const initialState = {};

const userLicenseReducer = (state = initialState, { type, payload, meta }) => {
  switch (type) {
    case USER_LICENSE_ACTION_TYPE.GET_USER_LICENSES:
      return payload || initialState;

    case USER_LICENSE_ACTION_TYPE.ADD_USER_LICENSE:
    case USER_LICENSE_ACTION_TYPE.EDIT_USER_LICENSE:
      return { ...state, [payload.id]: payload };

    case USER_LICENSE_ACTION_TYPE.DELETE_USER_LICENSE:
      return _.omit(state, [meta.licenseId]);

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default userLicenseReducer;
